/* ============================================================
   SPORTIVE HOMEPAGE - TABBED COLLECTIONS
   ============================================================ */

(function () {
  'use strict';

  function initTabs() {
    const tabSections = document.querySelectorAll('.sportive-tabs');

    tabSections.forEach(function (section) {
      const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
      const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));

      function activateTab(tab, i) {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        if (panels[i]) panels[i].classList.add('is-active');
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activateTab(tab, i); });

        tab.addEventListener('keydown', function (e) {
          let idx = i;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            idx = (i + 1) % tabs.length;
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            idx = (i - 1 + tabs.length) % tabs.length;
          } else if (e.key === 'Home') {
            e.preventDefault();
            idx = 0;
          } else if (e.key === 'End') {
            e.preventDefault();
            idx = tabs.length - 1;
          } else {
            return;
          }
          activateTab(tabs[idx], idx);
          tabs[idx].focus();
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initTabs);
})();
